// Module
var code = "<signal-and-contract-ratio-grid on-reset=\"onSignalAndContractRatioGridReset()\"></signal-and-contract-ratio-grid>";
// Exports
module.exports = code;